import API_BASE_URL from "../utils/config";
import request from "../utils/request";
import { v4 as uuidv4 } from "uuid";

export async function httpGetAudios(data) {
  const url = `${API_BASE_URL}/multimedia-files`;
  return request({
    url,
    method: "get",
    data,
  });
}

export async function httpGetAudio(data) {
  const url = `${API_BASE_URL}/multimedia-files/${data}`;
  return request({
    url,
    method: "get",
  });
}

export async function httpDeleteAudio(data) {
  const url = `${API_BASE_URL}/multimedia-files/${data}`;
  return request({
    url,
    method: "delete",
  });
}

export async function httpPostAudioFile(data) {
  const modData = { file: data, name: uuidv4() };
  const url = `${API_BASE_URL}/multimedia-files`;
  const formData = toFormData(modData);
  return request({
    url,
    method: "post",
    formData,
    upload: true,
    config: {
      headers: {
        "content-type": "multipart/form-data",
      },
    },
  });
}

function toFormData(data) {
  const formData = new FormData();
  formData.append("file", data.file);
  formData.append("name", data.name);
  return formData;
}
